import { render } from "./DownloadIcon.vue?vue&type=template&id=6f8fadfe"
const script = {}

import "./DownloadIcon.vue?vue&type=style&index=0&id=6f8fadfe&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__